<template>
  <div class="wx_blankBox">
    <!-- {{ urlP }} -->
    <div v-html="paramsUrl"></div>
  </div>
</template>
<script>
import utils from "@/utils/index";
import { Base64 } from "js-base64";
import api from "@/api/api";
import { Toast } from "vant";
export default {
  data() {
    return {
      urlP: "",
      paramsUrl: ""
    };
  },
  methods: {
    /**
     * @method openUrl
     * @description 打开url
     */
    openUrl() {
      Toast.loading({
        message: this.$i18n.t("common.payingText"),
        forbidClick: true
      });
      api.apiMethod.goPay
        .post(
          {
            businessCode: utils.getUrlSearch("businessCode"),
            payProduct: utils.getUrlSearch("payProduct"),
            merchantPayNo: utils.getUrlSearch("merchantPayNo")
          },
          {
            checkoutToken: utils.getUrlSearch("checkoutToken")
          }
        )
        .then(res => {
          Toast.clear();
          if (res.data.code === 10000) {
            // 微信支付
            let url = Base64.decode(res.data.data.url);
            // alert(url)
            // this.urlP = url;
            window.location.href = url;
          } else {
            // 失败
          }
        });
    }
  },
  created() {
    if (this.$route.params.paramsUrl) {
      this.paramsUrl = Base64.decode(this.$route.params.paramsUrl);
    }
  },
  mounted() {
    if (this.$route.params.paramsUrl) {
      document.forms[0].submit();
    } else {
      this.openUrl();
    }
  }
};
</script>
